// Type
import { UnitLibraries } from "pages/Libraries/type";

// Lib
import { compareSort } from "../helpers";

// Interface
interface GetImageSourcesProps {
  lib: { fileTypes?: string[], catNumber?: string };
  config: { api: { apiUrl: string } };
  filterFn: (params: { data: string[]; key: string }) => string[];
}

export const filteredData = (data: any, type: number, isAlphabetica?: boolean) => {
  let result: [] = [];

  if (!isAlphabetica) {
    result = data
      .filter((x: UnitLibraries) => x.bioType === type)
      .sort((x: UnitLibraries, y: UnitLibraries) =>
        ("" + x?.catNumber || "").localeCompare(y?.catNumber || "")
      ) || [];
  }

  if (isAlphabetica) {
    result = data
      .filter((x: UnitLibraries) => x.bioType === type)
      .sort(compareSort("name")) || [];
  }

  return result;
};

export const pxToPt = (px?: number) => {
  if (!px) return;
  const ptPerPx = 72 / 96;
  return px * ptPerPx;
};

export const getImageSources = ({ lib, config, filterFn }: GetImageSourcesProps) => {
  const fileTypes = lib?.fileTypes || [];
  const imgRight = filterFn({ data: fileTypes, key: "IMG_RIGHT" });
  const imgCenter = filterFn({ data: fileTypes, key: "IMG_CENTER" });

  const baseUrl = `${config.api.apiUrl}libs/${lib?.catNumber}/images`;

  return {
    imgRight,
    imgCenter,
    srcRight: imgRight.length ? `${baseUrl}/${imgRight[0]}` : "",
    srcCenter: imgCenter.length ? `${baseUrl}/${imgCenter[0]}` : "",
  };
};
